module.exports = __webpack_public_path__ + "img/law3m.1a81421e.jpg";